/** @module Enums */ /** typedoc */
var ReleaseContributorRoleEnum;
(function (ReleaseContributorRoleEnum) {
    ReleaseContributorRoleEnum["Actor"] = "Actor";
    ReleaseContributorRoleEnum["Arranger"] = "Arranger";
    ReleaseContributorRoleEnum["Choir"] = "Choir";
    ReleaseContributorRoleEnum["Conductor"] = "Conductor";
    ReleaseContributorRoleEnum["Engineer"] = "Engineer";
    ReleaseContributorRoleEnum["Ensemble"] = "Ensemble";
    ReleaseContributorRoleEnum["Mixer"] = "Mixer";
    ReleaseContributorRoleEnum["Orchestra"] = "Orchestra";
    ReleaseContributorRoleEnum["Producer"] = "Producer";
    ReleaseContributorRoleEnum["Remixer"] = "Remixer";
    ReleaseContributorRoleEnum["Soloist"] = "Soloist";
})(ReleaseContributorRoleEnum || (ReleaseContributorRoleEnum = {}));

export { ReleaseContributorRoleEnum };
